// @flow
import styled from 'styled-components';
import { g400, black } from '../../colors';
/*::
import type { Node } from 'react';

export type BreadcrumbsThemeType = {|
  Main: * => Node,
  Link: * => Node,
  Inactive: * => Node,
  SplitterIcon: * => Node,
  RootIcon: * => Node,
  LinkWrapper: * => Node,
|};
*/

var thm
/*: BreadcrumbsThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1ybbbw6-0"
  })(["color:", ";margin:0;display:flex;flex-direction:row;align-items:center;&>:first-child{margin-left:0;}"], g400()),
  LinkWrapper: styled.div.withConfig({
    displayName: "theme__LinkWrapper",
    componentId: "sc-1ybbbw6-1"
  })(["display:flex;flex-direction:row;align-items:center;"]),
  Link: styled.a.withConfig({
    displayName: "theme__Link",
    componentId: "sc-1ybbbw6-2"
  })(["color:", ";text-decoration:none;margin-left:0.5rem;margin-right:0.5rem;&:hover{color:", ";text-decoration:underline;}"], g400(), black()),
  Inactive: styled.span.withConfig({
    displayName: "theme__Inactive",
    componentId: "sc-1ybbbw6-3"
  })(["color:", ";margin-left:0.5rem;margin-right:0.5rem;"], black()),
  SplitterIcon: styled.img.withConfig({
    displayName: "theme__SplitterIcon",
    componentId: "sc-1ybbbw6-4"
  })(["width:1.5rem;height:1.5rem;align-self:center;margin:0 1rem;"]),
  RootIcon: styled.img.withConfig({
    displayName: "theme__RootIcon",
    componentId: "sc-1ybbbw6-5"
  })(["width:2.4rem;height:2.4rem;cursor:pointer;"])
};
export default thm;